const STYLES = [
    'polaroid-drop',
    'film-scan',
    'spotlight',
    'stack-fan',
    'social-card',
];

let counter = 0;

export function nextEntranceClass() {
    const style = STYLES[counter % STYLES.length];
    counter++;
    return `lw-entrance-${style}`;
}

const KEN_BURNS = ['lw-ken-burns-a', 'lw-ken-burns-b', 'lw-ken-burns-c', 'lw-ken-burns-d'];
let kbCounter = 0;

export function nextKenBurnsClass() {
    const cls = KEN_BURNS[kbCounter % KEN_BURNS.length];
    kbCounter++;
    return cls;
}
